import { Sparkles, MoreHorizontal, Send } from 'lucide-react';
import styles from './DeviceMockup.module.css';

/**
 * The signature visual: two overlapping phone frames showing the
 * "Solvora Assistant" chat product — an intro screen with a mascot
 * illustration, and a live conversation screen.
 */
export default function DeviceMockup() {
  return (
    <div className={styles.stage}>
      <div className={styles.glow} aria-hidden="true" />

      {/* ---- Phone 1: intro / mascot screen ---- */}
      <div className={`${styles.phone} ${styles.phoneBack}`}>
        <div className={styles.notch} />
        <div className={styles.screen}>
          <div className={styles.chatHeader}>
            <Sparkles size={14} className={styles.sparkle} />
            <span>Solvora Assistant</span>
          </div>

          <div className={styles.mascotArea}>
            {/*
              ASSET SLOT: robot / mascot illustration.
              Replace the placeholder below with:
              <img src="/src/assets/robot-assistant.png" alt="Solvora AI assistant mascot" className={styles.mascotImg} />
              Recommended: transparent PNG or WebP, ~600x700px.
            */}
            <div className={styles.mascotPlaceholder}>
              <span>Robot mascot</span>
              <span className={styles.mascotHint}>src/assets/robot-assistant.png</span>
            </div>
          </div>

          <div className={styles.introBubble}>
            <span className={styles.introHi}>Hi! I'm Sol.</span>
            <span className={styles.introText}>How can I help you achieve your goals today?</span>
          </div>

          <div className={styles.dots}>
            <span className={styles.dotActive} />
            <span className={styles.dot} />
            <span className={styles.dot} />
          </div>
        </div>
      </div>

      {/* ---- Phone 2: live conversation screen ---- */}
      <div className={`${styles.phone} ${styles.phoneFront}`}>
        <div className={styles.notch} />
        <div className={styles.screen}>
          <div className={styles.chatHeader}>
            <Sparkles size={14} className={styles.sparkle} />
            <span>Solvora Assistant</span>
            <MoreHorizontal size={16} className={styles.moreIcon} />
          </div>

          <div className={styles.thread}>
            <div className={styles.bubbleUser}>
              Hi Sol, I need some ideas for an e-commerce platform.
            </div>
            <div className={styles.bubbleBotRow}>
              <Sparkles size={12} className={styles.bubbleBotIcon} />
              <div className={styles.bubbleBot}>
                Great! I'd be happy to help. What kind of e-commerce solution are you building?
              </div>
            </div>
            <div className={styles.bubbleUser}>
              Something that supports multi-vendor, secure payments, and real-time analytics.
            </div>
            <div className={styles.bubbleBotRow}>
              <Sparkles size={12} className={styles.bubbleBotIcon} />
              <div className={styles.bubbleBot}>
                Awesome! I can suggest the right features, tech stack, and roadmap for you.
              </div>
            </div>
          </div>

          <div className={styles.inputRow}>
            <span className={styles.inputPlaceholder}>Ask Sol anything…</span>
            <span className={styles.sendBtn}><Send size={14} /></span>
          </div>
        </div>
      </div>
    </div>
  );
}
